// extracted by mini-css-extract-plugin
export default {"title-selected-prompts":"TitleSelectedPrompts_title-selected-prompts__JaQ4X"};